import $global from '../../store/global'

export const BackupKeys = {
  /** 真正存储用户数据的key */
  userinfo: `${$global.localStorageStartsWith}User`,

  /** h5原本的用户信息备份 */
  user_h5_backup: `${$global.localStorageStartsWith}User__H5__Backup`,
  /** h5原本的Token信息备份 */
  token_h5_backup: `${$global.localStorageStartsWith}Token__H5__Backup`,
  /** uc小程序用户信息备份 */
  user_uc_backup: `${$global.localStorageStartsWith}User__UC__Backup`,
  /** uc小程序Token信息备份 */
  token_uc_backup: `${$global.localStorageStartsWith}Token__UC__Backup`,
  /** 展览小程序用户信息备份 */
  user_show_backup: `${$global.localStorageStartsWith}User__Show_Backup`,
  /** 展览小程序Token信息备份 */
  token_show_backup: `${$global.localStorageStartsWith}Token__Show_Backup`
}
